import React from 'react';
import LocalizedMessage from 'react-l10n';

function CartModalHeader(props) {
    return (
        <div className='cart-modal__header'>
            <button
                className='cart-modal__close'
                data-toggle-cart
                title='Close'
            >
                <i className='icon icon-close-thin' />
            </button>
            <div className='cart-modal__title'>
                <div className='cart-modal__title-icon'>
                    <span className='icon icon-cart' />
                </div>
                <span className='heading heading--lv2'>
                    <LocalizedMessage id={'CART'} />
                </span>
            </div>
        </div>
    );
}

export default CartModalHeader;
